export default __webpack_public_path__ + "locales/ar-SA/DowngradePlanDialog.json?hash=fd5021cdcdbe8a250628b7f7d799b2ed";